import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import { toast } from "react-toastify";

class   TypesalaryForm extends Component{

    state = {
        id : "",
        type : "",
        category : "",
        max : null,
        error : "",
        
        isModal : false,
        title : "",
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    storeTypesalary = (val = null) =>{
        var data = {
                type : this.state.type,
                category : this.state.category,
                max : this.state.max > 0 ?  this.state.max : 1,
                operation : this.state.id ? (val === 1 ? "Archiver" : "Editer" ) : "Ajouter",
            }

        var request = this.state.id ? axios.put('typesalaries/'+this.state.id, data) : axios.post('typesalaries', data);
        request.then((response) =>{
            this.props.showModal()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error) => {
            this.setState({
                error : error.response.data.msg
            })
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }
    
    edit=()=>  {
        this.form()
    }

    form=()=>{
        this.setState({
            id: this.props.formData ? this.props.formData.id : "",
            type: this.props.formData ? this.props.formData.type : "",
            category: this.props.formData ? this.props.formData.category : "",
            max: this.props.formData ? this.props.formData.max : null,
            title : this.props.formData ? "Modifier le type sortie" : "Ajouter le type sortie",
            error : "",
        })
    }

    showModal = () => {
        this.setState({
            isModal : !this.state.isModal,
        })
    }

    render(){
        
        return(
            <div>
            <Modal 
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header>
                    <Modal.Title className="h6 font-monospace">{ this.state.title}</Modal.Title>
                </Modal.Header>
                    <Modal.Body className="row">
                        <div className="text-danger"><span className="text-danger text-small small">{ this.state.error }</span></div>
                        
                        <div className="col-md-12 mt-2 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Categorie</label>
                                <div className="position-relative mt-1">
                                    <select name="category" className="form-control form-control-sm"  onChange={this.handleInput} value={ this.state.category}>
                                        <option>.......</option>
                                        <option value="Wage">Salaire</option>
                                        <option value="Expense">Depense</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-12 mt-2 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Type du sortie</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="type"  value={this.state.type} id="nom-id-icon" />
                                    <div className="form-control-icon text-primary">
                                        <FeatherIcon icon="box"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12 mt-2 mt-2 d-none">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Montant maximun</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="max"  value={this.state.max} id="nom-id-icon" />
                                    <div className="form-control-icon text-primary">
                                        <FeatherIcon icon="dollar-sign"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button onClick={this.props.showModal} className="btn btn-outline-secondary btn-sm p-0 px-1"><FeatherIcon icon="corner-down-left"></FeatherIcon> Fermer</button>
                        <button onClick={() => this.storeTypesalary()} className="btn btn-sm btn-outline-primary p-0 px-1"><FeatherIcon icon="check-square"></FeatherIcon> Sauvegarder</button>
                    </Modal.Footer>
            </Modal>
            
 
        </div>
        )
    }
}
export default TypesalaryForm;